import React from 'react'
import { LandingNavbar } from "../components/Homepage/landing-navbar"
import Summarization from '../components/Summarization'

const SummarizationPage = () => {
    return (
        <main className="h-full bg-[#111827] overflow-auto">
            <div className="mx-auto max-w-screen-xl h-full w-full">
                <LandingNavbar />
                <Summarization />
            </div>
          </main>
    )
}

export default SummarizationPage